<template>
  <z-card-modal width="250" :opened="value" @change="$emit('input', $event)">
    <template #content>
      <div class="custom-title">{{ $t('title') }}</div>

      <v-form ref="form">
        <z-input
          v-model="internalFilterGroupName"
          required
          class="mt-4"
          :label="$t('filter_group_name')"
          :rules="groupNameRules"
        ></z-input>
      </v-form>

      <v-divider class="mb-4"></v-divider>

      <div class="d-flex justify-end">
        <z-btn
          class="mr-2"
          small
          rounded
          :text="$t('cancel')"
          @click="$emit('input', false)"
        ></z-btn>

        <z-btn
          primary
          small
          rounded
          :text="$t('save')"
          @click="onSaveGroup"
        ></z-btn>
      </div>
    </template>
  </z-card-modal>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      internalFilterGroupName: '',
    }
  },

  computed: {
    groupNameRules() {
      return [(v) => !!v || this.$t('required_field')]
    },
  },

  watch: {
    value: {
      handler() {
        this.internalFilterGroupName = ''

        this.$nextTick(() => {
          this.$refs.form.resetValidation()
        })
      },
    },
  },

  methods: {
    onSaveGroup() {
      const isValid = this.$refs.form.validate()

      if (isValid) {
        this.$emit('save-group', this.internalFilterGroupName)
        this.$emit('input', false)
      }
    },
  },

  i18n: {
    messages: {
      en: {
        title: 'Save filter selection',
        filter_group_name: 'Filter group name',
        required_field: 'Required field',
        cancel: 'Cancel',
        save: 'Save',
      },
      pt: {
        title: 'Salvar seleção de filtro',
        filter_group_name: 'Nome do grupo de filtro',
        required_field: 'Campo obrigatório',
        cancel: 'Cancelar',
        save: 'Salvar',
      },
      es: {
        title: 'Salvar selección de filtro',
        filter_group_name: 'Nombre del grupo de filtro',
        required_field: 'Campo obligatorio',
        cancel: 'Cancelar',
        save: 'Salvar',
      },
      fr: {
        title: 'Enregistrer la sélection du filtre',
        filter_group_name: 'Nom du groupe de filtres',
        required_field: 'Champ requis',
        cancel: 'Annuler',
        save: 'Enregistrer',
      },
      tr: {
        title: 'Filtre seçimini kaydet',
        filter_group_name: 'Filtre grup adı',
        required_field: 'Zorunlu alan',
        cancel: 'İptal',
        save: 'Kaydet',
      },
    },
  },
}
</script>
